<div class="workspace bg-radial">
  <top-bar 
    [ngClass]="getAccent()" 
    class="bg-white border-none"
    [isBackButtonShown]="true"
    backButtonRouterLink="../../"
    backButtonText="{{ 'NAVIGATION.EXERCISES' | translate }}"
    >
    <div nav-title class="col-6 col-md text-center">
      <h4>{{ getExerciseSet() }}</h4>
      <span class="text-muted">{{ getChapter() }}</span>
    </div>
    <content details class="d-none d-md-block row mb-md-3 w-100">
      <div class="w-100 mb-3">
        <p class="text-muted text-start xsmall mb-0">
          {{ "EXERCISES.DETAILS.HEADER" | translate }}
        </p>
      </div>
    </content>
    <footer class="d-none d-md-flex">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a routerLink="../../">{{ "NAVIGATION.EXERCISES" | translate }}</a>
          </li>
          <li class="breadcrumb-item">
            <a (click)="goToExerciseSetsWithFilter()">
              {{ getExerciseSet() }}
            </a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            {{ getChapter() }}
          </li>
        </ol>
      </nav>
    </footer>
  </top-bar>
  <div class="container mt-md-3">
    <div class="row position-relative pb-3">
      <spinner class="w-100 spinner"></spinner>
    </div>
    <button
      class="btn btn-secondary btn-circle refresh"
      (click)="refreshData()"
    >
      <app-icon name="refresh"></app-icon>
    </button>
    <div class="questions-sets mb-4" *ngFor="let section of getSections()">
      <question-set 
        *ngIf="getSectionAvailability(section)"
        [section]="section"
        [availabilitiesMap]="getAvailabilities(section)"
        class="mb-3"
      >
      </question-set>
    </div>
  </div>
</div>
